import * as angular from "angular";
import {IController, IWindowService} from "angular";
import * as _ from "lodash";
import {OrdersService} from "../../../orders/services/orders-service.service";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {PricePlanBundleRequestsService} from "../../../price-plan/services/price-plan-bundle-requests.service";
import {AccountModel} from "../../../account/angular/models/account.model";
import {getFulfillmentLineItems} from "../../../fulfillment/utils/fulfillment-line-items.util";

export class OmsOrderDetailsPanelComponent implements IController {

  order: any;
  fulfillment: any;
  selectedSteps: any[];
  weightUnit: string;
  volumeUnit: string;
  distanceUnit: string;
  siteLabels: any;
  showSteps: boolean;
  showLineStatus: boolean;
  onOrderUpdate: Function;
  onDispatch: Function;
  onAutoAssign: Function;
  onAssignAgent: Function;
  onCancelService: Function;
  onCancelAttempt: Function;
  onResetService: Function;
  onAssignRoute: Function;
  onAssignResourceAllocation: Function;
  onAddNoteToService: Function;
  onCreateRoute: Function;
  onCompleteManually: Function;
  onSplit: Function;

  private orderCopy: any;
  private labelsMap: any;
  private originPods: any;
  private destinationPods: any;
  private currentSectionInEditMode: string = undefined;
  // private isOrderDetailsEditMode: boolean;
  private canCreateTag: boolean;
  private siteInfo: any;
  private availableDays: any;
  private packageSizes: any;
  private defaultItemSize: any;
  private spotDimensions: any;
  private includePriceForOms: any;
  private pickupDepotIds: any;
  private additionOptions: any;
  private identificationOptions: any;
  private customer: any;
  private formSectionsEditMode: any = {
    orderDetails: false,
    originInfo: false,
    destinationInfo: false,
    originPodsAdditionsAndNotes: false,
    destinationPodsAdditionsAndNotes: false,
    originAddress: false,
    destinationAddress: false,
    originTimeWindow: false,
    destinationTimeWindow: false,
    packages: false
  }
  private isEditMode: boolean = false;
  private customAddressEnabled: boolean;
  private dateTypes: string[] = [];
  private originSelectedDateType: string;
  private destinationSelectedDateType: string;
  private isWeightInTotal: boolean;
  private fulfillmentLinesOriginPods: any = {};
  private fulfillmentLinesDestinationPods: any = {};
  private fulfillmentLinesPackages: any = {};
  private siteMetaData: any;
  private orderMetaData: any = [];
  public siteMetaDataMap: any = {};
  public fulfillmentStepsByLineMap: Object = {};
  public selectedKeys: any;
  public sections: any;


  constructor(private IAMPermissions, private siteContextService: SiteContextService, private pricePlanBundleRequestsService: PricePlanBundleRequestsService,
              private ordersService: OrdersService, private $filter, private moment,
              private splitService: SplitService, private $state, private $window: IWindowService) {
  }

  $onInit() {
    this.orderCopy = angular.copy(this.order);
    this.canCreateTag = this.IAMPermissions.hasPermission('infoTags.create');
    this.siteInfo = this.siteContextService.getSiteInfo();
    this.isWeightInTotal = this.splitService.getOmsPackageTotalWeightIndication();
    this.labelsMap = {};
    this.sections = {
      origin: false,
      destination: false,
      timeWindow: false,
      packages: false
    }
    this.siteMetaData = this.splitService.getSiteMetaData();
    _.forEach(this.siteMetaData, metaData => {
      this.siteMetaDataMap[metaData.key] = metaData;
    })
    // this.dateTypes = ['timeWindow', 'appointment'];
    // if(_.get(this.orderCopy.fulfillmentLines[0], 'pickupTask')){
    //   this.originSelectedDateType = this.orderCopy.fulfillmentLines[0].pickupTask.schedulingRequired ? 'appointment' : this.dateTypes[0];
    // }
    // this.destinationSelectedDateType = this.orderCopy.fulfillmentLines[0].destinationTask.schedulingRequired ? 'appointment' : this.dateTypes[0];

    _.forEach(this.siteLabels, (l) => {
      this.labelsMap[l.name] = l;
    })

    if (this.order) {
      this.tasksPods();
    }

    this.fulfillmentStepsByLineMap = {};
    _.forEach(this.fulfillment.fulfillmentSteps, (step) => {
       if (!this.fulfillmentStepsByLineMap[step.fulfillmentLineId]) {
         this.fulfillmentStepsByLineMap[step.fulfillmentLineId] = [];
       }
      this.fulfillmentStepsByLineMap[step.fulfillmentLineId].push(step.id)
    })

    this._initOrderDetails();
  }

  $onChanges(changes) {
    if (changes.order && !changes.order.isFirstChange()) {
      this._initOrderDetails();
      this.tasksPods();
    }
    if (changes.selectedSteps && !changes.selectedSteps.isFirstChange()) {
      this.selectedKeys = [];
      _.forEach(this.selectedSteps, (step) => {
        this.selectedKeys[step.id] = true;
      })
    }
  }

  toggleEditMode(section) {
    this.formSectionsEditMode[section] = !this.formSectionsEditMode[section];
    this.isEditMode = _.some(this.formSectionsEditMode, (section) => {
      return section === true;
    });
  }

  onDemandAccountSelect(account: AccountModel) {
    this.orderCopy.accountId = _.get(account, 'id');
    this.orderCopy.fulfillmentLines[0].pickupTask.contact.name = _.get(account, 'name');
    this.orderCopy.fulfillmentLines[0].pickupTask.contact.businessName = _.get(account, 'name');
    this.orderCopy.fulfillmentLines[0].pickupTask.contact.phoneNo = _.get(account, 'phoneNumber');
    this.orderCopy.fulfillmentLines[0].pickupTask.location.id = _.get(account, 'id');
    this.setTaskAddress(_.get(account, 'address', {}), !_.isUndefined(account) ? 'ACCOUNT' : 'UNDEFINED', 'Pickup');

    this.pickupDepotIds = _.get(account, 'depotIds');

    if (account) {
      this.setAccountProgram(account.id);
    }
  }

  onAccountSelect(account, task, purpose) {

    if (!task.contact) {
      task.contact = {};
    }
    task.location.id = _.get(account, 'id');
    task.contact.name = _.get(account, 'name');
    task.contact.businessName = _.get(account, 'name');
    task.contact.phoneNo = _.get(account, 'phoneNumber');
    task.contact.additionalPhoneNo = this.$filter('bringozPhone')(_.get(account, 'additionalPhoneNo'));
    this.setTaskAddress(_.get(account, 'address', {}), !_.isUndefined(account) ? 'ACCOUNT' : 'UNDEFINED', purpose);
    // this._getTaskTimeSlotOptions();
  }

  onEditOrder(event) {
    const siteId = this.splitService.getSiteId();
    const url = this.$state.href('order.edit', {id: this.order.id, siteId: siteId});
    this.$window.open(url, '_blank');
  }

  onDepotSelect(depot, task, purpose) {

    if (!task.contact) {
      task.contact = {};
    }

    task.location.id = _.get(depot, 'id');
    task.contact.name = _.get(depot, 'name');
    task.contact.businessName = _.get(depot, 'name');
    task.contact.phoneNo = this.$filter('bringozPhone')(_.get(depot, 'phoneNumber'));
    task.contact.additionalPhoneNo = this.$filter('bringozPhone')(_.get(depot, 'additionalPhoneNo'));
    task.contact.customerId = undefined;
    this.setTaskAddress(_.get(depot, 'address', {}), !_.isUndefined(depot) ? 'DEPOT' : 'UNDEFINED', purpose);

    // this._getTaskTimeSlotOptions();
  }

  onCustomerSelect(customer, task, purpose) {

    if (!task.contact) {
      task.contact = {};
    }

    this.customer = customer;
    task.location.id = _.get(customer, 'id');
    task.contact.name = this.getCustomerName(customer);
    task.contact.businessName = _.get(customer, 'businessName');
    task.contact.phoneNo = _.get(customer, 'phone');
    task.contact.email = _.get(customer, 'email');
    task.contact.customerId = _.get(customer, 'id');
    // this.task.contact.additionalPhoneNo = _.get(customer, 'additionalPhoneNo');

    const address = _.find(_.get(customer, 'addresses', []), (a) => {
      return a.id === customer.defaultAddressId;
    })
    this.setTaskAddress(address, 'CUSTOM', purpose);
  }

  onSearchCustomerChange(searchText, task) {
    task.contact.name = searchText;
    if (!searchText) {
      task.contact = {};
      this.customer = undefined;
    }
  }

  onTagsChange(tagNames) {
    this.orderCopy.tags = tagNames;
  }

  onPhoneChange(phone, task) {
    task.contact.phoneNo = phone;
  }

  onIdentificationsChange(identifications, task) {
    task.identifications = identifications;
  }

  onAdditionsChange(additions, task) {
    task.additions = additions;
  }

  setTaskAddress(address, locationType, purpose) {
    if (purpose === 'Pickup') {
      const pickupRef = angular.copy(this.orderCopy.fulfillmentLines[0].pickupTask);
      pickupRef.location.address = address;
      pickupRef.location.locationType = locationType;
      this.orderCopy.fulfillmentLines[0].pickupTask = pickupRef;
    }
    if (purpose === 'Destination') {
      const destinationRef = angular.copy(this.orderCopy.fulfillmentLines[0].destinationTask);
      destinationRef.location.address = address;
      destinationRef.location.locationType = locationType;
      this.orderCopy.fulfillmentLines[0].destinationTask = destinationRef;
    }
  }

  onSelectDateType(selectedDateType, task) {
    task.schedulingRequired = undefined;
    task.obligateTimeWindow = undefined;
    if (selectedDateType === 'timeWindow') {
      task.notBefore = this.moment().startOf('day').valueOf();
      task.notAfter = this.moment().endOf('day').valueOf();
    } else {
      task.notBefore = undefined;
      task.notAfter = undefined
      task.schedulingRequired = true;
    }
  }

  onAddPackage() {
    const defaultItem = _.find(this.packageSizes, (p) => {
      return p.itemSize === this.defaultItemSize;
    });
    if (defaultItem) {
      this.defaultItemSize = angular.copy(_.get(defaultItem, 'itemSize'));
    }
    const newPackage = {
      count: 1,
      barcode: null,
      size: _.get(defaultItem, 'itemSize'),
      type: _.get(defaultItem, 'itemSize'),
      labels: _.get(defaultItem, 'labels', []),
      dimensions: _.get(defaultItem, 'dimensions', {}),
      weight: _.get(defaultItem, 'weight'),
      totalWeight: this.isWeightInTotal ? _.get(defaultItem, 'weight') : undefined,
    };
    if (!this.order.itemLines) {
      this.order.itemLines = [];
    }
    this.order.itemLines = this.order.itemLines.concat([angular.copy(newPackage)]);
  }

  onToggleCustomAddress() {
    this.customAddressEnabled = !this.customAddressEnabled;
  }

  cancel() {
    this.orderCopy = angular.copy(this.order);
    this.currentSectionInEditMode = undefined;
  }

  onSubmit(form) {
    form.$setSubmitted(true);
    if (form.$valid) {
      Object.keys(this.formSectionsEditMode).forEach(section => {
        this.formSectionsEditMode[section] = false
      });
      this.isEditMode = false;
      this.onOrderUpdate({order: this.orderCopy});
    }
  }

  private _initOrderDetails(){
    _.forEach(this.order.fulfillmentLines, line => {
      this.fulfillmentLinesPackages[line.id] = [];
      this.fulfillmentLinesPackages[line.id] = getFulfillmentLineItems(line, this.order.itemLines)
    })
    _.forEach(this.order.metaData, m => {
      const siteMetaDataIndex = _.findIndex(this.siteMetaData, (item: any) => {
        return item.key === m.key;
      });
      if(siteMetaDataIndex > -1 && !!this.siteMetaData[siteMetaDataIndex].active){
        this.orderMetaData.push(m);
      }
    });
  }

  private setAccountProgram(accountId) {
    this.pricePlanBundleRequestsService.getDefaultProgramTypeByServiceType(accountId, 'Delivery')
      .then((defaultProgram) => {
        this.loadOrderSettings(accountId, 'Delivery', defaultProgram.pricePlanId, undefined, true);

        this.pricePlanBundleRequestsService.getPricePlanBundleByAccountId(accountId)
          .then((pricePlanBundle) => {

            const selectedProgram = _.find(pricePlanBundle.entryList, (e) => {
              return e.id === defaultProgram.id;
            })
            this.order.fulfillmentLines[0].programType = selectedProgram.type;
            this.order.fulfillmentLines[0].programName = selectedProgram.name;
          })

      })
  }

  private loadOrderSettings(accountId, serviceType, pricePlanId?, programType?, setPackages?) {
    this.ordersService.getOrderSettings(accountId, serviceType, programType, undefined, pricePlanId)
      .then((orderSettings) => {
        this.availableDays = _.get(orderSettings, 'availableDays', []);
        this.packageSizes = orderSettings.itemSizeList;
        this.defaultItemSize = orderSettings.defaultItemSize;
        this.spotDimensions = orderSettings.spotDimensions;
        this.includePriceForOms = orderSettings.includePriceForOms;
        this.additionOptions = _.get(orderSettings, 'additions', []);

        this.identificationOptions = {
          Pickup: this.ordersService.buildIdentificationOptions(
            orderSettings.pickupPodSettings,
            orderSettings.pickupPodFillRequiredSettings
          ),
          Destination: this.ordersService.buildIdentificationOptions(
            orderSettings.dropoffPodSettings,
            orderSettings.dropoffPodFillRequiredSettings
          )
        };


        if (!!setPackages) {
          const defaultItemSizeItem = _.find(this.packageSizes, (p) => {
            return p.itemSize === _.get(orderSettings, 'defaultItemSize');
          });
          if (defaultItemSizeItem) {
            this.order.itemLines = [
              {
                count: 1,
                barcode: null,
                type: defaultItemSizeItem.itemSize || 'NoPackage',
                labels: defaultItemSizeItem.labels || [],
                dimensions: defaultItemSizeItem.dimensions || {},
                weight: defaultItemSizeItem.weight
              }
            ];
          }
        }
      })
  }

  private getCustomerName(customer) {
    return _.get(customer, 'firstName', '') + ' ' + _.get(customer, 'lastName', '');
  }

  private tasksPods() {

    _.forEach(this.order.fulfillmentLines, fulfillmentLine => {
      if (_.get(fulfillmentLine, 'pickupTask')) {
        this.fulfillmentLinesOriginPods[fulfillmentLine.id] = _.chain(fulfillmentLine.pickupTask.identifications)
          .pickBy((value, key) => {
            return value === true;
          })
          .keys()
          .value();
      }
      if (_.get(fulfillmentLine, 'destinationTask')) {
        this.fulfillmentLinesDestinationPods[fulfillmentLine.id] = _.chain(fulfillmentLine.destinationTask.identifications)
          .pickBy((value, key) => {
            return value === true;
          })
          .keys()
          .value();
      }
    })
  }

}

angular
  .module('bringoz.admin.oms')
  .component('omsOrderDetailsPanel', {
    bindings: {
      order: '<',
      fulfillment: '<',
      selectedSteps: '<?',
      weightUnit: '<',
      volumeUnit: '<',
      distanceUnit: '<',
      siteLabels: '<',
      showSteps: '<?',
      showLineStatus: '<?',
      onToggleSelect: '&',
      onOrderUpdate: '&',
      onDispatch: '&',
      onAutoAssign: '&',
      onAssignAgent: '&',
      onCancelService: '&',
      onCancelAttempt: '&',
      onResetService: '&',
      onAssignRoute: '&',
      onAssignResourceAllocation: '&',
      onAddNoteToService: '&',
      onCreateRoute: '&',
      onCompleteManually: '&',
      onSplit: '&'
    },
    template: require('./oms-order-details-panel.html').default,
    controller: OmsOrderDetailsPanelComponent
  });
